import { OrderedMap, Map, fromJS, List } from "immutable";
import moment from "moment";
import { combineReducers } from "redux";
import {
  SAVE_FORM_DRAFT,
  REMOVE_FORM_DRAFT,
  SET_FORM_OPEN,
  SET_FORM_CLOSED,
  UPLOAD_FILE_BEGINS,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_GDRIVE_FILES_SUCCESS,
  UPLOAD_DROPBOX_FILES_SUCCESS,
  REMOVE_UPLOADED_FILE,
  REMOVE_ATTACHED_FILE,
  REMOVE_UNFINISHED_FILE_UPLOADS,
  UPDATE_FORM_DRAFT_TIMESTAMP,
} from "~/store/action_types";

const open = (state = OrderedMap(), action) => {
  const { formKey } = action;

  if (!formKey) return state;

  switch (action.type) {
    case SET_FORM_OPEN:
      return state.set(formKey, action.id);
    case SET_FORM_CLOSED:
      return state.remove(formKey);
    default:
      return state;
  }
};

const draft = (state = Map(), action) => {
  const { formData = {} } = action;

  switch (action.type) {
    case SAVE_FORM_DRAFT:
    case UPDATE_FORM_DRAFT_TIMESTAMP:
      state = state.set(`timestamp`, moment.utc().valueOf());
      return state.merge(fromJS(formData));
    case REMOVE_UPLOADED_FILE:
      return state.set(
        `attach_uploaded_files`,
        state.get(`attach_uploaded_files`, List()).filter((code) => code !== action.code)
      );
    case REMOVE_ATTACHED_FILE:
      return state.set(
        `drop_attached_files`,
        state.get(`drop_attached_files`, List()).concat(List([action.attachmentId]))
      );
    case UPLOAD_FILE_SUCCESS:
      return state.set(
        `attach_uploaded_files`,
        state
          .get(`attach_uploaded_files`, List())
          .filter((id) => action.file.code !== id)
          .concat(
            List(
              fromJS(action.response.entities.uploaded_files)
                .map((uploadedFile) => uploadedFile.get(`code`))
                .toArray()
            )
          )
      );
    case UPLOAD_GDRIVE_FILES_SUCCESS:
      return state.set(
        `attach_uploaded_files`,
        state
          .get(`attach_uploaded_files`, List())
          .filter((id) => {
            return action.docs.map((doc) => doc.code).indexOf(id) < 0;
          })
          .concat(
            List(
              fromJS(action.response.entities.uploaded_files)
                .map((uploadedFile) => uploadedFile.get(`code`))
                .toArray()
            )
          )
      );
    case UPLOAD_DROPBOX_FILES_SUCCESS:
      return state.set(
        `attach_uploaded_files`,
        state
          .get(`attach_uploaded_files`, List())
          .filter((id) => {
            return action.files.map((file) => file.code).indexOf(id) < 0;
          })
          .concat(
            List(
              fromJS(action.response.entities.uploaded_files)
                .map((uploadedFile) => uploadedFile.get(`code`))
                .toArray()
            )
          )
      );
    default:
      return state;
  }
};

const drafts = (state = OrderedMap(), action) => {
  const { formKey } = action;

  if (!formKey) return state;

  switch (action.type) {
    case UPLOAD_DROPBOX_FILES_SUCCESS:
    case UPLOAD_GDRIVE_FILES_SUCCESS:
    case UPLOAD_FILE_SUCCESS:
    case REMOVE_UPLOADED_FILE:
    case REMOVE_ATTACHED_FILE:
    case SAVE_FORM_DRAFT:
      return state.set(formKey, draft(state.get(`${formKey}`, undefined), action));
    case REMOVE_FORM_DRAFT:
      return state.remove(`${formKey}`);
    case UPDATE_FORM_DRAFT_TIMESTAMP:
      if (state.get(`${formKey}`)) {
        return state.set(formKey, draft(state.get(`${formKey}`, undefined), action));
      }
      return state;
    case SET_FORM_CLOSED:
      return state.remove(`${formKey}_${action.id}`);
    default:
      return state;
  }
};

const unfinished_file_uploads = (state = OrderedMap(), action) => {
  const { formKey } = action;

  if (!formKey) return state;

  switch (action.type) {
    case REMOVE_UNFINISHED_FILE_UPLOADS:
      return state.remove(`${formKey}`);
    case UPLOAD_FILE_BEGINS:
      return state.set(formKey, state.get(`${formKey}`, List()).concat(List([action.file.code])));
    case UPLOAD_FILE_SUCCESS:
      return state.set(
        formKey,
        state.get(`${formKey}`, List()).filter((code) => code !== action.file.code)
      );
    default:
      return state;
  }
};

export default combineReducers({
  open,
  drafts,
  unfinished_file_uploads,
});
